import React from 'react';
import { FlameIcon } from 'lucide-react';
interface ScarcityBarProps {
  spotsLeft?: number;
  total?: number;
}
export function ScarcityBar({
  spotsLeft = 12,
  total = 300
}: ScarcityBarProps) {
  const claimed = total - spotsLeft;
  const percent = Math.round(claimed / total * 100);
  return <div className="w-full rounded-xl border border-alert/40 bg-navy-900/80 p-4" data-id="element-46" data-mp="2q3he0scypgd2">
      <div className="mb-2 flex items-center justify-between gap-2" data-id="element-47" data-mp="2b6qhcquoair5">
        <span className="flex items-center gap-1.5 text-[11px] sm:text-xs font-bold uppercase tracking-wide text-alert" data-id="element-48" data-mp="2b8urvrn2ug0e">
          <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-49" data-mp="226207n9zg2a1" />
          Only {spotsLeft} spots left
        </span>
        <span className="text-[11px] sm:text-xs font-bold uppercase tracking-wide text-sky-200/70" data-id="element-50" data-mp="274vh7pohabey">
          {percent}% claimed
        </span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-navy-700" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch pricing spots claimed" data-id="element-51" data-mp="fgqw91m3s49">
        <div className="h-full rounded-full bg-alert transition-[width] duration-500 ease-out" style={{
        width: `${percent}%`
      }} data-id="element-52" data-mp="2zm2y3rppx89z" />
      </div>
      <p className="mt-2 text-center text-[11px] sm:text-xs text-sky-200/70" data-id="element-53" data-mp="38dlcpy70ng0y">
        {spotsLeft} spots remain at the promotional price of $27.
      </p>
    </div>;
}